import { useEffect, useState, useCallback } from 'react';
import server from '../global/server';

let offsetMs = 0;
let synced = false;

/**
 * Hook que sincroniza o relógio do frontend com o servidor.
 * Calcula o offset uma vez e aplica em todos os usos.
 *
 * Uso:
 *   const { now } = useServerTime();
 *   const currentTime = now(); // retorna Date ajustada pelo offset do servidor
 */
export const useServerTime = () => {
    const [ready, setReady] = useState(synced);

    useEffect(() => {
        if (synced) return;

        const sync = async () => {
            try {
                const before = Date.now();
                const { data } = await server.get('/auth/server-time');
                const after = Date.now();

                // Compensar latência da requisição (round-trip / 2)
                const latency = (after - before) / 2;
                const serverMs = new Date(data.serverTime).getTime();
                const clientMs = before + latency;

                offsetMs = serverMs - clientMs;
                synced = true;
                setReady(true);

                console.log(`⏱️ Server time sync: offset=${offsetMs}ms (latencia=${Math.round(latency)}ms)`);
            } catch (err) {
                console.warn('Falha ao sincronizar horário com servidor:', err.message);
                synced = true; // Usa relógio local como fallback
                setReady(true);
            }
        };

        sync();
    }, []);

    const now = useCallback(() => {
        return new Date(Date.now() + offsetMs);
    }, []);

    return { now, ready, offsetMs };
};

/**
 * Retorna a hora do servidor sem precisar do hook (para uso fora de componentes).
 * Só funciona depois que o hook foi usado pelo menos uma vez.
 */
export const getServerNow = () => new Date(Date.now() + offsetMs);
